import React, {useEffect} from 'react';
import { Link, useLocation } from 'react-router-dom';
import $ from "jquery";
import feather from "feather-icons";
import {getToken, logoutUser} from '../../api/auth';
import PerfectScrollbar from 'perfect-scrollbar';
import {useDispatch, useSelector} from "react-redux";

const Header = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state) => state.auth.user);

    const location = useLocation();
    const { pathname } = location;

    const onLogoutClick = (event) => {
        event.preventDefault();
        dispatch(logoutUser());
    };

    useEffect(() => {

        dispatch(getToken());

        $(function () {
            'use strict';
            feather.replace();

            const asideBody = new PerfectScrollbar('.aside-body', {
                suppressScrollX: true
            });

            if($('.aside-backdrop').length === 0) {
                $('body').append('<div class="aside-backdrop"></div>');
            }

            var mql = window.matchMedia('(min-width:992px) and (max-width: 1199px)');

            function doMinimize(e) {
                if (e.matches) {
                    $('.aside').addClass('minimize');
                } else {
                    $('.aside').removeClass('minimize');
                }

                asideBody.update()
            }

            mql.addListener(doMinimize);
            doMinimize(mql);

            $('.aside-menu-link').on('click', function(e){
                e.preventDefault();

                if(window.matchMedia('(min-width: 992px)').matches) {
                    $(this).closest('.aside').toggleClass('minimize');
                } else {

                    $('body').toggleClass('show-aside');
                }

                asideBody.update()
            });

            $('.nav-aside .with-sub').on('click', '.nav-link', function(e){
                e.preventDefault();

                $(this).parent().siblings().removeClass('show');
                $(this).parent().toggleClass('show');

                asideBody.update()
            });

            $('body').on('mouseenter', '.minimize .aside-body', function(e){
                $(this).parent().addClass('maximize');
            });

            $('body').on('mouseleave', '.minimize .aside-body', function(e){
                $(this).parent().removeClass('maximize');

                asideBody.update()
            });

            $('body').on('click', '.aside-backdrop', function(e){
                $('body').removeClass('show-aside');
            })
        });
    }, []);

    return (
        <aside className="aside aside-fixed">
            <div className="aside-header">
                <a href="#" className="aside-logo">
                    <img src="/assets/img/logo-hz.png" className="img-fluid ht-30" alt=""/>
                </a>
                <a href="#" className="aside-menu-link">
                    <i data-feather="menu"></i>
                    <i data-feather="x"></i>
                </a>
            </div>
            <div className="aside-body">
                <div className="aside-loggedin">
                    <div className="aside-loggedin-user">
                        <a href="#loggedinMenu" className="d-flex align-items-center justify-content-between mg-b-2"
                           data-toggle="collapse">
                            <h6 className="tx-semibold mg-b-0">{auth.user.name}</h6>
                            <i data-feather="chevron-down"></i>
                        </a>
                        <p className="tx-color-03 tx-12 mg-b-0">{auth.user.role}</p>
                    </div>
                    <div className="collapse" id="loggedinMenu">
                        <ul className="nav nav-aside mg-b-0">
                            <li className="nav-item"><Link to="#" onClick={onLogoutClick.bind()} className="nav-link"><i data-feather="log-out"></i>
                                <span>Sign Out</span></Link></li>
                        </ul>
                    </div>
                </div>

                <ul className="nav nav-aside">
                    <li className="nav-label">General</li>
                    <li className={`nav-item ${pathname === '/dashboard' ? 'active' : ''}`}><Link to="/dashboard" className="nav-link"><i data-feather="activity"></i> <span>Overview</span></Link></li>
                    <li className={`nav-item ${pathname === '/report' ? 'active' : ''}`}><Link to="/report" className="nav-link"><i data-feather="users"></i> <span>Order</span></Link></li>
                    <li className={`nav-item ${pathname === '/report' ? 'active' : ''}`}><Link to="/report" className="nav-link"><i data-feather="repeat"></i> <span>Transactions</span></Link></li>
                    <li className={`nav-item ${pathname === '/message' ? 'active' : ''}`}><Link to="/message" className="nav-link"><i data-feather="box"></i> <span>Product</span></Link></li>
                    <li className={`nav-item ${pathname === '/agent' ? 'active' : ''}`}><Link to="/agent" className="nav-link"><i data-feather="package"></i> <span>Inventory</span></Link></li>
                    <li className="nav-label mg-t-25">Settings</li>
                    <li className={`nav-item ${pathname === '/access_control' ? 'active' : ''}`}><Link to="/access_control" className="nav-link"><i data-feather="settings"></i> <span>Access Control</span></Link></li>
                </ul>
            </div>
        </aside>
    );
};

export default Header;
